"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useContextFactory = void 0;

var react_1 = require("react");
/**
 *
 *
 * @export
 * @param {string} id
 * @returns {string}
 */


function useContextFactory(name, context) {
  return function () {
    var contextValue = react_1.useContext(context);

    if (contextValue === undefined) {
      throw new Error("use".concat(name, "Context must be used within a ").concat(name, "ContextProvider."));
    }

    return contextValue;
  };
}

exports.useContextFactory = useContextFactory;